if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select && select.addEventListener('change', (e) => {
        const value = e.target.value
        const form = select.closest('[data-localization-form]')
        const input = form.querySelector('input[data-localization-input]')
        input && input.setAttribute('value', value)
        input && form.submit()
      });
    }
  }
  customElements.define('m-localization-form', MLocalizationForm);
}

// custom for snow in
 const canvas = document.getElementById("snow");
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    // canvas.height = window.innerHeight;
    canvas.height = 500;

    const snowflakes = [];
    function Snowflake() {
      this.x = Math.random() * canvas.width;
      this.y = Math.random() * canvas.height;
      this.radius = Math.random() * 3 + 1;
      this.speed = Math.random() * 1 + 0.5;
      this.wind = Math.random() * 0.5 - 0.25;
    }
    Snowflake.prototype.update = function () {
      this.y += this.speed;
      this.x += this.wind;
      if (this.y > canvas.height) {
        this.y = -this.radius;
        this.x = Math.random() * canvas.width;
      }
    };
    Snowflake.prototype.draw = function () {
      ctx.globalAlpha = 0.5;
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
      ctx.fillStyle = "white";
      ctx.fill();
    };
    function createSnowflakes(count) {
      for (let i = 0; i < count; i++) {
        snowflakes.push(new Snowflake());
      }
    }
    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (let flake of snowflakes) {
        flake.update();
        flake.draw();
      }
      requestAnimationFrame(animate);
    }
    createSnowflakes(200);
    animate();
    // Adjust canvas size on window resize
    window.addEventListener("resize", () => {
      canvas.width = window.innerWidth;
      // canvas.height = window.innerHeight;
    });


// New Pattren
(function () {
  const canvases = document.querySelectorAll(".snowPatternCanvas");

  canvases.forEach(canvas => {
    const ctx = canvas.getContext("2d");

    function resizeCanvas() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    const flakeShapes = ["✻", "✼", "✽", "✾", "✺"];
    const flakes = [];

    function SnowPatternFlake() {
      this.x = Math.random() * canvas.width;
      this.y = Math.random() * canvas.height;
      this.size = Math.random() * 40 + 10;
      this.speed = Math.random() * 0.3 + 0.2;
      this.opacity = Math.random() * 0.5 + 0.1;
      this.wind = Math.random() * 0.4 - 0.2;
      this.char = flakeShapes[Math.floor(Math.random() * flakeShapes.length)];
    }

    SnowPatternFlake.prototype.update = function () {
      this.y += this.speed;
      this.x += this.wind;

      if (this.y > canvas.height) {
        this.y = -20;
        this.x = Math.random() * canvas.width;
      }
    };

    SnowPatternFlake.prototype.draw = function () {
      ctx.globalAlpha = this.opacity;
      ctx.font = this.size + "px Arial";
      ctx.fillStyle = "white";
      ctx.fillText(this.char, this.x, this.y);
    };

    for (let i = 0; i < 80; i++) {
      flakes.push(new SnowPatternFlake());
    }

    function animateSnowPattern() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      flakes.forEach(flake => {
        flake.update();
        flake.draw();
      });
      requestAnimationFrame(animateSnowPattern);
    }

    animateSnowPattern();
  });
})();







